import { render, staticRenderFns } from "./ReadModal.vue?vue&type=template&id=85e3d32a&"
import script from "./ReadModal.vue?vue&type=script&lang=js&"
export * from "./ReadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports